// (c) chaehongee. Confidential and proprietary.

import type { ButtonHTMLAttributes, ReactElement } from 'react'

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactElement
}

export function IconButton({ children, className, ...rest }: IconButtonProps): ReactElement {
    const classes = ['iconButton']
    if (className) classes.push(className)
    return (
        <button className={classes.join(' ')} {...rest}>
            {children}
        </button>
    )
}

export default IconButton


